<template>
    <XModal ref="modal" title="模块设置" okText="保存" :ok="submit">
        <AFormModel ref="settingForm" :model="formData" :rules="rules" :label-col="{ span: 6 }"
            :wrapper-col="{ span: 18 }">
            <AFormModelItem label="模块模式" prop="moduleType">
                <ARadioGroup name="radioGroup" v-model="formData.moduleType" @change="onRadioChange">
                    <ARadioButton v-if="userInfo.userType.name == '管理员'" value="OVERALL">全局</ARadioButton>
                    <ARadioButton v-if="userInfo.userType.name=='后台用户'" value="USER" >用户</ARadioButton>
                </ARadioGroup>
            </AFormModelItem>
        </AFormModel>
        <!--根据模块模式调整界面显示-->
        <div v-show="formData.moduleType" v-if="dataSource.btnList">
            <XTable :columns="columns" :dataSource="dataSource.btnList.slice(0, 10)" rowKey="code" :indexWidth="0" 
                :scroll="{ x: 460, y: 300 }" :paging="false">
                <template v-slot:btnName="{ record, cellData }">
                    <AInput class="mr5" :value="cellData" @change="e => customNameInputChange(e.target.value, record)">
                    </AInput>
                </template>
                <template v-slot:isMoudleShow="{ record, cellData }">
                    <ASwitch v-if="record.defName" :checked="cellData" @change="onSwitchChange(record)"></ASwitch>
                </template>
            </XTable>
        </div>
        <!-- <div v-show="formData.moduleType=='user'">
            1
        </div>
        <div v-show="formData.moduleType=='station'">
            2
        </div> -->
    </XModal>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
// import menuList from '@/menu/menu2'
import {
    saveTerminalMenuSettings
} from '@api'
export default {
    components: {},
    props: {},
    data() {
        return {
            authType: null,
            formData: {
                moduleType: '',
            },
            rules: {
                moduleType: [
                    { required: true, message: '请选择模块模式', trigger: 'blur' },
                ],
            },
            columns: [
                // {
                //     title: '模块名称',
                //     dataIndex: 'defName',
                //     width: 120
                // },
                {
                    title: '自定义名称',
                    dataIndex: 'btnName',
                    scopedSlots: { customRender: 'btnName' },
                    width: 280
                },
                {
                    title: '显示',
                    dataIndex: 'enable',
                    scopedSlots: { customRender: 'isMoudleShow' },
                },
            ],
            dataSource: {},
            customNameSaved: ''
        }
    },
    computed: {
        ...mapGetters(['userInfo', 'getOverAllMoudleSetting', 'getUserModuleSetting','getUsedModuleType'])
    },
    created() { 
    },
    mounted() { 
    },
    methods: {
        ...mapActions(['refreshTerminalMenu']),
        open() {
            this.formData.moduleType=this.getUsedModuleType(this.userInfo)
            this.$refs.modal.open()
        },
        async submit() {
            //表单验证
            if (!await this.$refs.settingForm.validate()) {
                return false
            }
            localStorage.setItem("moduleType",this.formData.moduleType)
            await saveTerminalMenuSettings(this.formData.moduleType, this.dataSource)
            this.$message.success("设置成功！")
      location.reload()
            return true
        },
        onRadioChange(e) {
            this.formData.moduleType = e.target.value
        },
        customNameInputChange(value, record) {
            let target = this.dataSource.btnList.find(item => record.defName === item.defName);
            if (target) {
                target.btnName = value
            }
        },
        onSwitchChange(record) {
            let target = this.dataSource.btnList.find(item => record.defName === item.defName);
            if (target) {
                target.enable = !target.enable
            }
        }
    },
    watch: {
        async 'formData.moduleType'() {
            await this.refreshTerminalMenu()
            switch (this.formData.moduleType) {
                case "OVERALL":
                    this.dataSource =JSON.parse(JSON.stringify( this.getOverAllMoudleSetting))
                    break
                case "USER":
                    this.dataSource =JSON.parse(JSON.stringify( this.getUserModuleSetting))
                    break
            }
        }
    }
}
</script>
<style lang='less' scoped>
/deep/ .ant-table-scroll .ant-table-header {
    overflow: auto !important;
    padding-bottom: 17px !important;
}
</style>